/*!
 * Xtenia Score, advanced calisthenics assessment
 * Copyright (c) 2026 Xtenia. All rights reserved.
 * https://www.xtenia.com
 *
 * Proprietary software. Unauthorized copying, distribution,
 * or use of this code is prohibited without written permission.
 */

/* ============================================================
   Xtenia SCORE, result renderer
   Phase 5.

   Reads the computed engine result and renders the 5 result
   cards on Step 6.
============================================================ */

(function() {
  'use strict';

  window.WD = window.WD || {};
  window.WD.score = window.WD.score || {};
  var WS = window.WD.score;
  WS.result = WS.result || {};

  function t(key) {
    return (WS.t && key) ? WS.t(key) : (key || '');
  }

  function el(tag, className, attrs) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (attrs) for (var k in attrs) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else n.setAttribute(k, attrs[k]);
    }
    return n;
  }

  // ============================================================
  // XTENIA METHOD referral
  // Maps the user's tier to the matching free program and renders
  // a call-to-action card that deep-links to the XTENIA Method page.
  // Copy is localized inline so this needs no i18n file changes.
  // ============================================================
  var WM_I18N = {
    en: {
      label: "Your free program",
      title: "Your next step: The Xtenia Method",
      desc_foundation: "Build your base the right way. The free Foundation program takes you from where you are now to your first clean pull-up, L-sit and handstand, step by step.",
      desc_athlete: "You have a real base now. The free Athlete program is an 8-week block toward the straddle front lever, advanced tuck planche and your first muscle-up.",
      desc_advanced: "You are operating at a high level. Xtenia Method Advanced is coming soon, the next frontier of straight-arm strength and elite skills. Join the waitlist to be first in.",
      cta: "Get the free program",
      cta_advanced: "Join the Advanced waitlist"
    },
    es: {
      label: "Tu programa gratis",
      title: "Tu siguiente paso: The Xtenia Method",
      desc_foundation: "Construye tu base de la forma correcta. El programa Foundation gratis te lleva desde donde estás ahora hasta tu primera dominada limpia, L-sit y pino, paso a paso.",
      desc_athlete: "Ya tienes una base real. El programa Athlete gratis es un bloque de 8 semanas hacia el straddle front lever, el advanced tuck planche y tu primer muscle-up.",
      desc_advanced: "Estás a un nivel alto. Xtenia Method Advanced llega pronto, la siguiente frontera de fuerza en brazo recto y movimientos de élite. Únete a la lista para ser de los primeros.",
      cta: "Consigue el programa gratis",
      cta_advanced: "Únete a la lista de Advanced"
    },
    de: {
      label: "Dein kostenloses Programm",
      title: "Dein nächster Schritt: The Xtenia Method",
      desc_foundation: "Bau deine Basis richtig auf. Das kostenlose Foundation Programm bringt dich Schritt für Schritt von deinem aktuellen Stand zu deinem ersten sauberen Klimmzug, L-sit und Handstand.",
      desc_athlete: "Du hast jetzt eine echte Basis. Das kostenlose Athlete Programm ist ein 8-Wochen-Block in Richtung Straddle Front Lever, Advanced Tuck Planche und deinem ersten Muscle-up.",
      desc_advanced: "Du bist auf hohem Niveau. Xtenia Method Advanced kommt bald, die nächste Stufe aus Straight-Arm-Kraft und Elite-Skills. Trag dich in die Warteliste ein, um zuerst dabei zu sein.",
      cta: "Hol dir das kostenlose Programm",
      cta_advanced: "Auf die Advanced Warteliste"
    },
    fr: {
      label: "Ton programme gratuit",
      title: "Ta prochaine étape : The Xtenia Method",
      desc_foundation: "Construis ta base correctement. Le programme Foundation gratuit t'emmène de ton niveau actuel à ta première traction propre, ton L-sit et ton équilibre, étape par étape.",
      desc_athlete: "Tu as maintenant une vraie base. Le programme Athlete gratuit est un bloc de 8 semaines vers le straddle front lever, l'advanced tuck planche et ton premier muscle-up.",
      desc_advanced: "Tu évolues à un haut niveau. Xtenia Method Advanced arrive bientôt, la prochaine étape de force bras tendus et de figures d'élite. Rejoins la liste pour être parmi les premiers.",
      cta: "Obtiens le programme gratuit",
      cta_advanced: "Rejoindre la liste Advanced"
    },
    it: {
      label: "Il tuo programma gratuito",
      title: "Il tuo prossimo passo: The Xtenia Method",
      desc_foundation: "Costruisci le basi nel modo giusto. Il programma Foundation gratuito ti porta dal tuo livello attuale alla tua prima trazione pulita, all'L-sit e alla verticale, passo dopo passo.",
      desc_athlete: "Ora hai una base vera. Il programma Athlete gratuito è un blocco di 8 settimane verso lo straddle front lever, l'advanced tuck planche e il tuo primo muscle-up.",
      desc_advanced: "Sei a un livello alto. Xtenia Method Advanced arriva presto, la prossima frontiera di forza a braccia tese e skill d'élite. Iscriviti alla lista per essere tra i primi.",
      cta: "Ottieni il programma gratuito",
      cta_advanced: "Iscriviti alla lista Advanced"
    },
    nl: {
      label: "Jouw gratis programma",
      title: "Je volgende stap: The Xtenia Method",
      desc_foundation: "Bouw je basis op de juiste manier. Het gratis Foundation programma brengt je stap voor stap van waar je nu staat naar je eerste strakke pull-up, L-sit en handstand.",
      desc_athlete: "Je hebt nu een echte basis. Het gratis Athlete programma is een blok van 8 weken richting de straddle front lever, advanced tuck planche en je eerste muscle-up.",
      desc_advanced: "Je zit op een hoog niveau. Xtenia Method Advanced komt binnenkort, de volgende grens van gestrekte-arm-kracht en elite-skills. Schrijf je in op de wachtlijst om er als eerste bij te zijn.",
      cta: "Haal het gratis programma",
      cta_advanced: "Op de Advanced wachtlijst"
    }
  };

  function wmLang() {
    var appEl = document.querySelector('.ws-app');
    var raw = (appEl && appEl.getAttribute('lang')) || document.documentElement.lang || 'en';
    return raw.slice(0, 2).toLowerCase();
  }

  function wmProgram(tier) {
    if (tier === 'foundation' || tier === 'builder') return 'foundation';
    if (tier === 'athlete' || tier === 'specialist') return 'athlete';
    return 'advanced'; // elite, mastery
  }

  function renderxteniaMethod(result) {
    var program = wmProgram(result.tier);
    var isAdvanced = (program === 'advanced');
    var d = WM_I18N[wmLang()] || WM_I18N.en;
    var programName = program === 'foundation' ? 'Foundation' : (program === 'athlete' ? 'Athlete' : 'Advanced');

    var card = el('div', 'ws-result-card ws-xtenia-card');

    // Left: text content
    var body = el('div', 'ws-wm-body');

    var label = el('div', 'ws-wm-label', { text: d.label });
    body.appendChild(label);

    var title = el('div', 'ws-wm-title', { text: d.title });
    body.appendChild(title);

    var prog = el('div', 'ws-wm-program', { text: programName });
    body.appendChild(prog);

    var desc = el('div', 'ws-wm-desc', { text: d['desc_' + program] });
    body.appendChild(desc);

    var base = 'https://www.xtenia.com/pages/the-xtenia-method';
    var localized = (WS.localizeUrl ? WS.localizeUrl(base) : base);
    var href = localized + (localized.indexOf('?') > -1 ? '&' : '?') + 'level=' + program;

    var btn = el('a', 'ws-btn ws-btn-primary ws-wm-btn', {
      href: href,
      text: (isAdvanced ? d.cta_advanced : d.cta) + ' →'
    });
    body.appendChild(btn);

    card.appendChild(body);

    // Right: image slot (URL set via CSS var so per-tier images stay editable)
    var media = el('div', 'ws-wm-media');
    media.setAttribute('data-program', program);
    card.appendChild(media);

    return card;
  }

  // ============================================================
  // CARD: SCORE HEADER (the hero card)
  // ============================================================
  function renderScoreHeader(result, answers) {
    var card = el('div', 'ws-result-card ws-score-hero');

    // Background glow effects
    var glow = el('div', 'ws-score-hero-glow');
    card.appendChild(glow);

    var inner = el('div', 'ws-score-hero-inner');

    // "Xtenia Score" badge
    var badge = el('div', 'ws-score-hero-badge', { text: t('result_badge') });
    inner.appendChild(badge);

    // Greeting (uses name if provided)
    if (answers.name && answers.name.trim()) {
      var greeting = el('div', 'ws-score-greeting');
      greeting.textContent = t('result_greeting').replace('{name}', answers.name.trim());
      inner.appendChild(greeting);
    }

    // Big number
    var scoreWrap = el('div', 'ws-score-bignum-wrap');
    var bignum = el('div', 'ws-score-bignum');
    bignum.setAttribute('data-target', String(result.total));
    bignum.textContent = '0';
    scoreWrap.appendChild(bignum);

    var scoreMax = el('div', 'ws-score-max', { text: '/ 1000' });
    scoreWrap.appendChild(scoreMax);
    inner.appendChild(scoreWrap);

    // Tier name
    var tierName = el('div', 'ws-score-tier');
    tierName.textContent = t('tier_' + result.tier);
    inner.appendChild(tierName);

    // Archetype line
    var archetype = el('div', 'ws-score-archetype');
    var archIcon = el('span', 'ws-score-archetype-icon', { text: archetypeIcon(result.archetype) });
    archetype.appendChild(archIcon);
    var archText = el('span', '', { text: t('archetype_' + result.archetype) });
    archetype.appendChild(archText);
    inner.appendChild(archetype);

    // Tagline (archetype description)
    var tagline = el('div', 'ws-score-tagline');
    tagline.textContent = t('archetype_' + result.archetype + '_tagline');
    inner.appendChild(tagline);

    // Action buttons
    var actions = el('div', 'ws-result-actions');

    var shareBtn = el('button', 'ws-btn ws-btn-primary', {
      type: 'button',
      text: t('result_share'),
      'aria-label': t('result_share')
    });
    shareBtn.addEventListener('click', function() {
      if (WS.share && typeof WS.share.open === 'function') {
        WS.share.open(result, answers);
      }
    });
    actions.appendChild(shareBtn);

    var retakeBtn = el('button', 'ws-btn ws-btn-ghost', {
      type: 'button',
      text: t('result_retake')
    });
    retakeBtn.addEventListener('click', function() {
      if (typeof WS.reset === 'function') WS.reset();
    });
    actions.appendChild(retakeBtn);

    inner.appendChild(actions);
    card.appendChild(inner);

    // Animate the big number on render
    requestAnimationFrame(function() {
      animateNumber(bignum, 0, result.total, 1400);
    });

    return card;
  }

  function archetypeIcon(key) {
    var icons = {
      athlete: '🏆',
      streetlifter: '⛓️',
      specialist: '🤸',
      foundation: '🌱',
      powerhouse: '💪',
      mobility: '🧘',
      hybrid: '⚡'
    };
    return icons[key] || '🏆';
  }

  function animateNumber(el, from, to, duration) {
    var start = performance.now();
    function tick(now) {
      var elapsed = now - start;
      var pct = Math.min(1, elapsed / duration);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - pct, 3);
      var current = Math.round(from + (to - from) * eased);
      el.textContent = String(current);
      if (pct < 1) requestAnimationFrame(tick);
      else el.textContent = String(to);
    }
    requestAnimationFrame(tick);
  }

  // ============================================================
  // CARD: PILLAR BREAKDOWN
  // ============================================================
  function renderBreakdown(result) {
    var card = el('div', 'ws-result-card ws-breakdown-card');

    var title = el('h3', 'ws-result-card-title', { text: t('result_breakdown_title') });
    card.appendChild(title);

    var sub = el('p', 'ws-result-card-sub', { text: t('result_breakdown_sub') });
    card.appendChild(sub);

    var list = el('div', 'ws-pillars');

    var pillars = [
      { key: 'strength',  emoji: '💪' },
      { key: 'skill',     emoji: '🤸' },
      { key: 'mobility',  emoji: '🧘' },
      { key: 'endurance', emoji: '🔥' },
      { key: 'movement',  emoji: '✨' }
    ];

    pillars.forEach(function(p, idx) {
      var row = el('div', 'ws-pillar');

      var head = el('div', 'ws-pillar-head');
      var labelWrap = el('div', 'ws-pillar-label');
      var emoji = el('span', 'ws-pillar-emoji', { text: p.emoji });
      labelWrap.appendChild(emoji);
      var name = el('span', 'ws-pillar-name', { text: t('pillar_' + p.key) });
      labelWrap.appendChild(name);

      // Add weakest/strongest tag
      if (p.key === result.weakestPillar) {
        var tagW = el('span', 'ws-pillar-tag ws-pillar-tag-weak', { text: t('pillar_tag_weakest') });
        labelWrap.appendChild(tagW);
      } else if (p.key === result.strongestPillar) {
        var tagS = el('span', 'ws-pillar-tag ws-pillar-tag-strong', { text: t('pillar_tag_strongest') });
        labelWrap.appendChild(tagS);
      }

      head.appendChild(labelWrap);

      var valueText = el('div', 'ws-pillar-value', { text: result.pillars[p.key] });
      head.appendChild(valueText);

      row.appendChild(head);

      var barTrack = el('div', 'ws-pillar-track');
      var barFill = el('div', 'ws-pillar-fill ws-pillar-fill-' + p.key);
      barFill.style.width = '0%';
      barTrack.appendChild(barFill);
      row.appendChild(barTrack);

      list.appendChild(row);

      // Animate fills with stagger
      setTimeout(function() {
        barFill.style.width = result.pillars[p.key] + '%';
      }, 200 + idx * 120);
    });

    card.appendChild(list);
    return card;
  }

  // ============================================================
  // CARD: FASTEST UNLOCK
  // ============================================================
  function renderFastestUnlock(result) {
    var card = el('div', 'ws-result-card ws-unlock-card');

    var iconWrap = el('div', 'ws-unlock-icon');
    iconWrap.textContent = '🎯';
    card.appendChild(iconWrap);

    var head = el('div', 'ws-unlock-head');
    var label = el('div', 'ws-unlock-label', { text: t('unlock_label') });
    head.appendChild(label);

    var skillName = el('div', 'ws-unlock-skill', { text: t(result.fastestUnlock.skillKey) });
    head.appendChild(skillName);

    var meta = el('div', 'ws-unlock-meta');

    var daysWrap = el('div', 'ws-unlock-days');
    var daysNum = el('span', 'ws-unlock-days-num', { text: String(result.fastestUnlock.days) });
    daysWrap.appendChild(daysNum);
    var daysLabel = el('span', 'ws-unlock-days-label', { text: t('unlock_days') });
    daysWrap.appendChild(daysLabel);
    meta.appendChild(daysWrap);

    var transition = el('div', 'ws-unlock-transition');
    transition.innerHTML =
      '<span class="ws-unlock-from">' + t(result.fastestUnlock.currentTier) + '</span>' +
      '<span class="ws-unlock-arrow">→</span>' +
      '<span class="ws-unlock-to">' + t(result.fastestUnlock.nextTier) + '</span>';
    meta.appendChild(transition);

    head.appendChild(meta);
    card.appendChild(head);

    return card;
  }

  // ============================================================
  // CARD: CEILING PROJECTION
  // ============================================================
  function renderCeiling(result) {
    var card = el('div', 'ws-result-card ws-ceiling-card');

    var iconWrap = el('div', 'ws-ceiling-icon');
    iconWrap.textContent = '📈';
    card.appendChild(iconWrap);

    var head = el('div', 'ws-ceiling-head');
    var label = el('div', 'ws-ceiling-label', { text: t('ceiling_label') });
    head.appendChild(label);

    var msg = el('div', 'ws-ceiling-msg');
    var ceilingText = t('ceiling_message')
      .replace('{months}', result.ceiling.months)
      .replace('{tier}', t(result.ceiling.tierKey));
    msg.innerHTML = ceilingText;
    head.appendChild(msg);

    var note = el('div', 'ws-ceiling-note', { text: t('ceiling_note') });
    head.appendChild(note);

    card.appendChild(head);
    return card;
  }

  // ============================================================
  // CARD: RECOMMENDATIONS
  // 1 product + 1 bundle + 1 article
  // ============================================================
  function renderRecommendations(result) {
    var card = el('div', 'ws-result-card ws-recs-card');

    var title = el('h3', 'ws-result-card-title', { text: t('recs_title') });
    card.appendChild(title);

    var sub = el('p', 'ws-result-card-sub', { text: t('recs_sub') });
    card.appendChild(sub);

    var grid = el('div', 'ws-recs-grid');

    if (result.recommendations.product) {
      grid.appendChild(renderRecCard('product', result.recommendations.product, t('rec_label_product')));
    }
    if (result.recommendations.bundle) {
      grid.appendChild(renderRecCard('bundle', result.recommendations.bundle, t('rec_label_bundle')));
    }
    if (result.recommendations.article) {
      grid.appendChild(renderRecCard('article', result.recommendations.article, t('rec_label_article')));
    }

    card.appendChild(grid);
    return card;
  }

  function renderRecCard(type, rec, labelText) {
    var key = rec.key;
    var url = t(key + '_url');
    var title = t(key + '_title');
    var desc = t(key + '_desc');

    var a = el('a', 'ws-rec-card ws-rec-card-' + type, {
      href: WS.localizeUrl ? WS.localizeUrl(url) : url,
      target: '_blank',
      rel: 'noopener'
    });

    var typeLabel = el('div', 'ws-rec-type', { text: labelText });
    a.appendChild(typeLabel);

    var titleEl = el('div', 'ws-rec-title', { text: title });
    a.appendChild(titleEl);

    var descEl = el('div', 'ws-rec-desc', { text: desc });
    a.appendChild(descEl);

    var cta = el('div', 'ws-rec-cta');
    cta.innerHTML = '<span>' + t('rec_cta') + '</span><span class="ws-rec-arrow">→</span>';
    a.appendChild(cta);

    return a;
  }

  // ============================================================
  // PUBLIC: render the full result screen
  // ============================================================
  WS.result.render = function(answers) {
    var main = document.getElementById('ws-main');
    if (!main) return;

    // Compute result if not already cached
    var result;
    if (WS.state && WS.state.result && WS.state.result.computedAt) {
      result = WS.state.result;
    } else {
      if (!WS.engine || typeof WS.engine.compute !== 'function') {
        main.innerHTML = '<div class="ws-card ws-error">Scoring engine not loaded.</div>';
        return;
      }
      result = WS.engine.compute(answers);
      if (WS.state) {
        WS.state.result = result;
        WS.state.completedAt = Date.now();
        if (typeof WS._saveState === 'function') WS._saveState();
      }
    }

    // Render
    main.innerHTML = '';

    var wrap = el('div', 'ws-result-screen');

    wrap.appendChild(renderScoreHeader(result, answers));
    wrap.appendChild(renderBreakdown(result));
    wrap.appendChild(renderFastestUnlock(result));
    wrap.appendChild(renderCeiling(result));
    wrap.appendChild(renderxteniaMethod(result));
    wrap.appendChild(renderRecommendations(result));

    // Polish v9: comparison code, PDF download, compare widget
    if (typeof WS.renderCodeBlock === 'function') {
      wrap.appendChild(WS.renderCodeBlock(result, answers));
    }
    if (typeof WS.renderCompareSection === 'function') {
      wrap.appendChild(WS.renderCompareSection(result));
    }

    main.appendChild(wrap);
  };

})();
